// src/pages/packages/steps/PackageStep3.jsx
import "./PackageStep3.scss";

import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";

import AppButton from "../../../../../commons/buttons/AppButton";
import AppContainer from "../../../../../commons/containers/AppContainer";
import AppCurrencyInputV2 from "../../../../../commons/inputs/AppCurrencyInputV2";
import AppLinkButton from "../../../../../commons/buttons/AppLinkButton";
import HallAppToast from "../../../../../commons/HallAppToast";

/**
 * Step 3 (Valores) - v1 (SEM DESCONTO)
 * - Preço do pacote
 */

function PackageStep3({ formik, toBack, onSave }) {
  const { values: globalValues, setFieldValue: setGlobalFieldValue } = formik;

  // Currency input control (igual seu padrão)
  const [priceValue, setPriceValue] = useState(
    Number(globalValues?.priceAmount ?? globalValues?.price ?? 0)
  );

  useEffect(() => {
    setPriceValue(Number(globalValues?.priceAmount ?? globalValues?.price ?? 0));
  }, [globalValues?.priceAmount, globalValues?.price]);

  const goSave = () => {
    if (!Number(priceValue || 0) || Number(priceValue || 0) <= 0) {
      HallAppToast.error("Informe o valor do pacote.");
      return;
    }

    // salva no formik global
    setGlobalFieldValue("priceAmount", Number(priceValue || 0));

    // se existirem campos antigos de desconto no formik global, zera pra não vazar no payload
    setGlobalFieldValue("allowDiscount", false);
    setGlobalFieldValue("discountType", null);
    setGlobalFieldValue("maxDiscountPercent", null);
    setGlobalFieldValue("maxDiscountAmount", null);

    onSave?.();
  };

  return (
    <div className="package-step3" style={{ paddingBottom: 110 }}>
      <div className="mb-3">
        <div className="package-step3__title">Valores</div>
        <div className="package-step3__subtitle text-muted">
          Defina o preço do pacote.
        </div>
      </div>

      <div className="package-step3__card">
        <div className="package-step3__card-title">Preço do pacote</div>

        <Row className="g-2">
          <Col xs={12} md={6}>
            <AppCurrencyInputV2
              label="Valor"
              isRequired
              value={priceValue}
              onChange={(_, v) => setPriceValue(v)}
            />
            <div className="package-step3__hint-mini text-muted">
              Esse é o valor final do pacote.
            </div>
          </Col>
        </Row>
      </div>

      {/* Footer */}
      <div className="package-step3__footer">
        <AppContainer>
          <AppLinkButton name="Salvar" fullWidth={true} onClick={goSave} />
          <div style={{ marginTop: 10 }}>
            <AppButton name="Voltar" width="100%" onClick={toBack} />
          </div>
        </AppContainer>
      </div>
    </div>
  );
}

export default PackageStep3;